// extracted by mini-css-extract-plugin
module.exports = {"PinWheelColor":"pin-wheel-color_PinWheelColor__3zedD","rotate":"pin-wheel-color_rotate__LdSF8"};